<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormPanel
          :initial="topMenuLink.attributes"
          headline="Edit Top Menu Link"
          :errors="errors"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/TopMenuLinks/Panels/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {LoadingContainer, FormPanel},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      topMenuLink: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/top-menu-links/' + this.$route.params.topMenuLinkId).then(response => {
        this.topMenuLink = response.data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/top-menu-links/' + this.$route.params.topMenuLinkId, data)
          .then(response => {
            notify.success('The top menu link was saved')

            this.topMenuLink = response.data.data

            this.errors = {}
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
